import { render, staticRenderFns } from "./EndorsementDetails.vue?vue&type=template&id=25f3ff4b"
import script from "./EndorsementDetails.vue?vue&type=script&lang=js"
export * from "./EndorsementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports